import { Vue, Ref, Prop, Component, Emit } from 'vue-property-decorator'
import ConfigurationInstrumentationDevicesModalBasicForm
    from '@/modules/configurationModule/detail/instrumentation/devices/components/modal-basic-form/configuration-instrumentation-devices-modal-basic-form.vue'
import ConfigurationInstrumentationDevicesModalVisibilityForm
    from '@/modules/configurationModule/detail/instrumentation/devices/components/modal-visibility-form/configuration-instrumentation-devices-modal-visibility-form.vue'
import ConfigurationInstrumentationDevicesModalNotificationsForm
    from '@/modules/configurationModule/detail/instrumentation/devices/components/modal-notifications-form/configuration-instrumentation-devices-modal-notifications-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationInstrumentationDevicesModalState,
    initialConfigurationInstrumentationDevicesModalState
} from '@/modules/configurationModule/detail/instrumentation/devices/components/modal/configuration-instrumentation-devices-modal.model'
import {
    ConfigurationDeviceCreateRequest, ConfigurationDevicePatchInBatchRequest,
    ConfigurationDeviceResponse
} from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'

@Component({
    components: {
        ConfigurationInstrumentationDevicesModalBasicForm,
        ConfigurationInstrumentationDevicesModalVisibilityForm,
        ConfigurationInstrumentationDevicesModalNotificationsForm
    }
})
export default class ConfigurationInstrumentationDevicesModal extends Vue {
    @Ref() readonly devicesModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): ConfigurationDeviceCreateRequest {
        return {
            active: !!this.state.device.active,
            hasIntegration: !!this.state.device.hasIntegration,
            model: this.state.device.model!,
            name: this.state.device.name!,
            type: this.state.device.type!.code,
            useInternalViewer: this.state.device.useInternalViewer
        }
    }

    @Emit()
    update(): ConfigurationDevicePatchInBatchRequest {
        return {
            id: this.state.device.id!,
            active: !!this.state.device.active,
            hasIntegration: !!this.state.device.hasIntegration,
            model: this.state.device.model,
            name: this.state.device.name,
            type: this.state.device.type?.code,
            useInternalViewer: this.state.device.useInternalViewer
        }
    }

    state: ConfigurationInstrumentationDevicesModalState

    get updateMode(): boolean {
        return !!this.state.device?.id
    }

    constructor() {
        super()
        this.state = initialConfigurationInstrumentationDevicesModalState()
    }

    async show(device?: ConfigurationDeviceResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationInstrumentationDevicesModalState()
        if (device) {
            this.state.device = device
        }

        this.devicesModal.show()
    }

    hide(): void {
        this.devicesModal.hide()
    }
}
